import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { staffRecycle, staffRestore } from '../../../Services/Services';
import Popover from '@mui/material/Popover';


const StaffRestore = () => {
  const [users, setUsers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null)

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await staffRecycle(); // don't pass any argument if not needed
        setUsers(response);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

 
  const handleDelete = async (userId) => {
    try {
      const response = await staffRestore(userId); // don't pass any argument if not needed
      setUsers(response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

 

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }


  

  

  return (
    <Box>
     

      {/* Display Users in Table */}
      {users.length === 0 ? (
        <Typography>No users found.</Typography>
      ) : (
        <div id="printable-table">
          <TableContainer sx={{ overflowX: 'auto', maxWidth: '100%' }}>
            <Table size="small" sx={{ '& td, & th': { borderBottom: '1px solid #ccc' } }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5', '& th': { fontWeight: 'bold', color: '#333', borderBottom: '1px solid #999', whiteSpace: 'nowrap' } }}>
                  <TableCell align="center">S. No.</TableCell>
                  {/* <TableCell align="center">User ID</TableCell> */}
                  <TableCell align="center">Name</TableCell>
                  <TableCell align="center">Mobile No</TableCell>
                  <TableCell align="center">Email</TableCell>
                  {/* <TableCell align="center">Password</TableCell> */}
                  <TableCell align="center">Address</TableCell>
                  <TableCell align="center">Created</TableCell>
                  {/* <TableCell align="center">Updated</TableCell> */}
                  <TableCell align="center" className='no-print'>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user, index) => (
                  <TableRow key={user.userId}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                      "& td": {
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        fontSize: "0.8125rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 120,
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    <TableCell align="center">{index + 1}</TableCell>
                    {/* <TableCell align="center">{user.user_id || 'N/A'}</TableCell> */}
                    <TableCell align="center">{user.name}</TableCell>
                    <TableCell align="center">{user.mo_no}</TableCell>
                    <TableCell align="center">{user.email}</TableCell>

                    <TableCell align="center">{user.address}</TableCell>
                    <TableCell align="center">{formatOnlyDate(user.created_at)}</TableCell>
                    {/* <TableCell align="center">{formatOnlyDate(user.updated_at)}</TableCell> */}
                    <TableCell align="center" className='no-print'>
                
                      <IconButton
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setUserToDelete(user.user_id);
                        }}
                        color="error"
                        size="small"
                      >
                        <RestoreFromTrashIcon fontSize="small" style={{color:"blue"}}/>
                      </IconButton>

                      {/* <IconButton onClick={() => handleDelete(user.user_id)} color="error" size="small">
                        <DeleteIcon fontSize="small" />
                      </IconButton> */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )
      }


      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setUserToDelete(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleDelete(userToDelete);
                } finally {
                  setAnchorEl(null);
                  setUserToDelete(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setUserToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

    </Box >
  );
};

export default StaffRestore;
